import {
  FETCH_DWK_RESI_PROJECTS,
  FETCH_DWK_RESI_PROJECT,
  SEARCH_DWK_RESI_PROJECTS,
  FETCHING_DWK_RESI_PROJECTS,
} from '../actions/types';

const INITIAL_STATE = { 
  city:'', 
  fetching:true,  
  projectResis: [],
  projectResisForData :[],
  projectResi: null,
  offset: 0,
  limit: 10,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case FETCH_DWK_RESI_PROJECTS:
      return { ...state, ...action.payload };
    case FETCH_DWK_RESI_PROJECT:
      return { ...state, projectResi: action.payload };
    
    case SEARCH_DWK_RESI_PROJECTS:
     
      return { ...state, ...action.payload };
    
    case FETCHING_DWK_RESI_PROJECTS:
      return { ...state, fetching: action.payload };
    default:
      return state;
  }
};
